import React from 'react';
import RushEditComponent from '../components/RushEdit';
import { AddonsContextConsumer } from '../../../../context/AddonsContext';

function RushEdit(props) {
  return (
    <AddonsContextConsumer>
      {({
        constants: { RUSH_EDIT },
        constants,
        actions: { getAddonsCostByType, getCurrencySymbol }
      }) =>
      <RushEditComponent
        {...props}
        RUSH_EDIT={RUSH_EDIT}
        getAddonsCostByType={getAddonsCostByType}
        constants={constants}
        getCurrencySymbol={getCurrencySymbol} />}


    </AddonsContextConsumer>);

}

export default RushEdit;